import { render } from "./PagesDropdown.vue?vue&type=template&id=afdf259c"
import script from "./PagesDropdown.vue?vue&type=script&lang=js"
export * from "./PagesDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script